import type { TRootStatus } from '../../types/ux/status.ux.type';

type TStatusRequests = {
  [key: string]: TRootStatus;
};

export const requestStatus: TStatusRequests = {
  RG: {
    label: 'Registrado',
    bgColor: 'default',
    icon: 'clock',
    description: 'El ticket ha sido registrado, pronto empezarán a atenderlo.',
    visible: true,
  } as TRootStatus,
  PE: {
    label: 'Pendiente',
    bgColor: 'default',
    icon: 'clock',
    description: 'El ticket ha sido registrado, pronto empezarán a atenderlo.',
    visible: true,
  } as TRootStatus,
  EP: {
    label: 'En Proceso',
    bgColor: 'processing',
    icon: 'rotate',
    description: 'El ticket está siendo atentido, pronto podrás verificarlo.',
    visible: true,
  } as TRootStatus,
  PV: {
    label: 'Por Verificar',
    bgColor: 'warning',
    icon: 'clock',
    description: 'El ticket fue atendido, ahora debes verificar la resolución.',
    visible: true,
  } as TRootStatus,
  CE: {
    label: 'Cerrado',
    bgColor: 'success',
    icon: 'circle-check',
    description: 'El ticket atendido correctamente y cerrado por el usuario.',
    visible: true,
  } as TRootStatus,
  AN: {
    label: 'Anulado',
    bgColor: 'magenta',
    icon: 'circle-minus',
    description: 'El ticket fue anulado por el usuario o por los resolutores.',
    visible: true,
  } as TRootStatus,
  ER: {
    label: 'Error',
    bgColor: 'error',
    icon: 'circle-xmark',
    description: 'El procesamiento de la solicitud ha finalizado con errores.',
    visible: true,
  } as TRootStatus,
  RS: {
    label: 'Resuelto',
    bgColor: 'success',
    icon: 'circle-check',
    description: 'El procesamiento de la solicitud ha finalizado sin errores.',
    visible: true,
  } as TRootStatus,
  PA: {
    label: 'Pendiente de Aprobación',
    bgColor: 'default',
    icon: 'clock',
    description: 'La solicitud ha sido registrada y verificada por el usuario.',
    visible: true,
  } as TRootStatus,
  AP: {
    label: 'Aprobado',
    bgColor: 'green',
    icon: 'user-check',
    description: 'El procesamiento de la solicitud ha finalizado sin errores.',
    visible: true,
  } as TRootStatus,
  RE: {
    label: 'Rechazado',
    bgColor: 'red',
    icon: 'user-xmark',
    description: 'El procesamiento de la solicitud ha finalizado sin errores.',
    visible: true,
  } as TRootStatus,
  AS: {
    label: 'Anulado por el solicitante',
    bgColor: 'red',
    icon: 'user-xmark',
    description: 'El procesamiento de la solicitud ha finalizado sin errores.',
    visible: true,
  } as TRootStatus,
  TE: {
    label: 'Terminado',
    bgColor: 'success',
    icon: 'circle-check',
    description: 'El ticket atendido correctamente y cerrado por el usuario.',
    visible: true,
  } as TRootStatus,
};

export const requestStatusModal: TStatusRequests = {
  PE: {
    label: 'Pendiente',
    bgColor: 'default',
    icon: 'clock',
    description:
      'La solicitud ha sido registrada, pronto empezarán a atenderlo.',
    visible: true,
  } as TRootStatus,
  EP: {
    label: 'En Proceso',
    bgColor: 'processing',
    icon: 'rotate',
    description:
      'La solicitud está siendo atentida, pronto podrás verificarlo.',
    visible: true,
  } as TRootStatus,
  PV: {
    label: 'Por Verificar',
    bgColor: 'warning',
    icon: 'clock',
    description:
      'La solicitud fue atendida, ahora debes verificar la resolución.',
    visible: true,
  } as TRootStatus,
  CE: {
    label: 'Cerrado',
    bgColor: 'success',
    icon: 'circle-check',
    description:
      'La solicitud fue atendida correctamente y cerrado por el usuario.',
    visible: true,
  } as TRootStatus,
  AN: {
    label: 'Anulado',
    bgColor: 'magenta',
    icon: 'circle-minus',
    description:
      'La solicitud fue anulada por el usuario o por los resolutores.',
    visible: true,
  } as TRootStatus,
};

export const requestRouteStatusModal: TStatusRequests = {
  RG: {
    label: 'Registrado',
    bgColor: 'default',
    icon: 'clock',
    description:
      'La solicitud ha sido registrada, pronto empezarán a atenderlo.',
    visible: true,
  } as TRootStatus,
  EP: {
    label: 'En Proceso',
    bgColor: 'processing',
    icon: 'rotate',
    description:
      'La solicitud está siendo atentida, pronto podrás verificarlo.',
    visible: true,
  } as TRootStatus,
  TE: {
    label: 'Terminado',
    bgColor: 'success',
    icon: 'circle-check',
    description:
      'La solicitud fue atendida correctamente y cerrado por el usuario.',
    visible: true,
  } as TRootStatus,
  RE: {
    label: 'Rechazado',
    bgColor: 'magenta',
    icon: 'circle-minus',
    description:
      'La solicitud fue rechazada por el usuario o por los resolutores.',
    visible: true,
  } as TRootStatus,
  ER: {
    label: 'Error',
    bgColor: 'red',
    icon: 'circle-xmark',
    description: 'La solicitud tuvo un error al procesar.',
    visible: true,
  } as TRootStatus,
  PV: {
    label: 'Por Verificar',
    bgColor: 'yellow',
    icon: 'circle-question',
    description: 'La solicitud está en proceso de verificación.',
    visible: true,
  } as TRootStatus,
};

export const statusFilterRequests = [
  { name: 'Pendiente', code: 'PE' },
  { name: 'En Proceso', code: 'EP' },
  { name: 'Cerrado', code: 'CE' },
  { name: 'Anulado', code: 'AN' },
  { name: 'Por verificar', code: 'PV' },
  { name: 'Error', code: 'ER' },

  { name: 'Resuelto', code: 'RS' },
  { name: 'Pendiente de aprobación', code: 'PA' },
  { name: 'Aprobado', code: 'AP' },
  { name: 'Rechazado', code: 'RE' },
  { name: 'Anulado por el solicitante', code: 'AS' },

  { name: 'Terminado', code: 'TE' },
  { name: 'Registrado', code: 'RG' },
  { name: 'Rechazado', code: 'RE' },
];
